<template>
    <div>
        <nav class="paginations" v-if="!client">
            <span class="page-stats">{{pagination.from}} - {{pagination.to}} of {{pagination.total}}</span>
            <ul class="pagination mt-2">
                <li v-if="pagination.prevPageUrl" class="page-item previous">
                    <a @click.prevent="$emit('prev')" class="page-link">&nbsp;</a>
                </li>
                <li v-else class="page-item previous disabled">
                    <a class="page-link">&nbsp;</a>
                </li>

                <li v-if="pagination.nextPageUrl" class="page-item next">
                    <a @click.prevent="$emit('next')" class="page-link">&nbsp;</a>
                </li>
                <li v-else class="page-item next disabled">
                    <a class="page-link">&nbsp;</a>
                </li>
            </ul>
        </nav>

        <nav class="paginations" v-else>
            <span class="page-stats">
                {{pagination.from}} - {{pagination.to}} of {{filtered.length}}
                <span v-if="filtered.length < pagination.total">
                    (filtered from {{pagination.total}} total entries)
                </span>
            </span>
            <ul class="pagination mt-2">
                <li v-if="pagination.prevPage" class="page-item previous">
                    <a @click.prevent="$emit('prev')" class="page-link">&nbsp;</a>
                </li>
                <li v-else class="page-item previous disabled">
                    <a class="page-link">&nbsp;</a>
                </li>
                <li v-if="pagination.nextPage" class="page-item next">
                    <a @click.prevent="$emit('next')" class="page-link">&nbsp;</a>
                </li>
                <li v-else class="page-item next disabled">
                    <a class="page-link">&nbsp;</a>
                </li>
            </ul>
        </nav>
    </div>
</template>

<style lang="scss">
.paginations {

    display: grid;
    grid-template-columns: 60px 100px;
    justify-content: end;
    align-items: center;
    justify-items: end;

    /*
    justify-content: flex-end !important;
    .page-stats {
        align-items: center;
        margin-right: 5px;
    }
    i {
        color: #3273dc !important;
    }*/
}
</style>

<script>
    export default {
        props: ['pagination', 'client', 'filtered']
    }
</script>
